export const COLOR_PRESETS = [
  { label: "Default", value: "" },
  { label: "Blue", value: "#4477c2" },
  { label: "Red", value: "#c0454a" },
  { label: "Green", value: "#3a9e73" },
  { label: "Purple", value: "#8860c4" },
  { label: "Orange", value: "#d0744a" },
  { label: "Gray", value: "#8492a6" },
]
